import * as React from "react";
const SvgIconInteractive = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "40px", viewBox: "0 -960 960 960", width: "40px", fill: "#FFFFFF", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m320-80 40-280H160l360-520h80l-40 320h240L400-80h-80Z" }));
export default SvgIconInteractive;
